var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#cUser_svg__filter0_d_3720_50968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.474 14.77a1.595 1.595 0 011.54-1.179h48.39c.882 0 1.596.715 1.596 1.596v10.81c0 .88-.714 1.594-1.595 1.594h-51.32a1.595 1.595 0 01-1.54-2.012l2.929-10.81z",
    fill: "url(#cUser_svg__paint0_linear_3720_50968)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.715 14.835a1.345 1.345 0 011.299-.994h48.39c.744 0 1.346.603 1.346 1.346v10.81c0 .742-.602 1.344-1.345 1.344h-51.32c-.886 0-1.53-.841-1.299-1.697l2.93-10.81z",
    stroke: "url(#cUser_svg__paint1_linear_3720_50968)",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.013 21.651v2.043h3.321v.765h-7.605v-.765H30.8v-3.222h.819v3.222h1.512v-4.761h.882v1.971h2.502v.747h-2.502zm-.585-5.283l.756.36c-.063.099-.135.189-.207.288 1.134 1.269 2.439 1.953 3.78 2.493-.207.18-.441.468-.54.729-1.305-.612-2.52-1.332-3.708-2.646-.981 1.107-2.295 2.025-3.645 2.637a3.446 3.446 0 00-.576-.711c1.629-.639 3.249-1.8 4.14-3.15zm12.141 2.079l.765.369c-.423 1.071-1.008 2.313-1.494 3.159l-.693-.36c.477-.819 1.089-2.133 1.422-3.168zm-4.86 3.159l-.837.306c-.207-.828-.711-2.214-1.152-3.249l.765-.243c.45 1.026.99 2.376 1.224 3.186zm3.33 1.836h2.421v.828h-7.911v-.828h2.421v-6.876h.855v6.876h1.359v-6.867h.855v6.867zm7.947-2.196h2.178v-1.332h-2.178v1.332zm-2.826 0h1.989v-1.332h-1.953v.36c0 .306-.009.639-.036.972zm1.989-3.384h-1.953v1.269h1.953v-1.269zm3.015 1.269v-1.269h-2.178v1.269h2.178zm.837-2.07v6.597c0 .486-.117.738-.441.864-.333.135-.855.153-1.683.144a3.458 3.458 0 00-.279-.81c.576.027 1.17.018 1.341.018.162 0 .225-.054.225-.225v-1.611h-2.178v2.574h-.837v-2.574h-2.07c-.144.99-.468 1.998-1.125 2.727a2.77 2.77 0 00-.657-.549c.981-1.089 1.071-2.682 1.071-3.951v-3.204h6.633zm3.321 3.159h4.482v-1.629h-4.473v1.197c0 .144 0 .279-.009.432zm2.466-2.412h2.871v3.726h-.855v-.531h-4.518c-.108 1.278-.414 2.736-1.233 3.762a3.188 3.188 0 00-.729-.504c1.035-1.287 1.143-3.15 1.143-4.473v-1.98h2.88c-.09-.351-.288-.828-.45-1.197l.819-.216c.198.405.423.927.522 1.278l-.45.135z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.78 27.142a1 1 0 001.44 0l7.207-7.495a1 1 0 00.095-1.271l-3.088-4.362a1 1 0 00-.816-.423h-8.236a1 1 0 00-.816.423l-3.088 4.362a1 1 0 00.095 1.27l7.206 7.496z",
    fill: "#2C0309"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.36 16.591c-1.854 0-3.36 1.469-3.36 3.276 0 .692.217 1.327.594 1.864.087.113.174.226.26.325.13.14.261.268.406.38a3.39 3.39 0 002.1.72 3.39 3.39 0 002.1-.72 2.663 2.663 0 00-.42-.38 2.838 2.838 0 01-1.68.55 2.871 2.871 0 01-1.68-.55c-.16-.113-.29-.24-.42-.382a6.55 6.55 0 01-.26-.324 2.605 2.605 0 01-.45-1.483c0-1.51 1.26-2.74 2.81-2.74 1.549 0 2.809 1.23 2.809 2.74a2.72 2.72 0 01-.45 1.483c.146.113.29.24.42.38a3.186 3.186 0 00.594-1.863c-.014-1.807-1.52-3.276-3.373-3.276z",
    fill: "#FFD3DA",
    stroke: "#FFD3DA",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.864 22.084c-.13-.141-.26-.282-.405-.395a3.416 3.416 0 00-1.028-.551 3.338 3.338 0 00-1.072-.17c-.318 0-.593-.127-.796-.324a1.053 1.053 0 01-.319-.763c0-.607.507-1.087 1.115-1.087.609 0 1.115.494 1.115 1.087 0 .297-.115.565-.318.763.203.042.39.099.58.17.187-.27.303-.594.303-.933 0-.903-.753-1.638-1.68-1.638-.926 0-1.68.72-1.68 1.624 0 .353.117.678.305.932a1.677 1.677 0 001.376.706c.622 0 1.201.212 1.68.55.158.114.289.269.42.41.187.212.347.48.462.748h.609a3.721 3.721 0 00-.666-1.13z",
    fill: "url(#cUser_svg__paint2_linear_3720_50968)",
    stroke: "url(#cUser_svg__paint3_linear_3720_50968)",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cUser_svg__paint0_linear_3720_50968",
    x1: 67.843,
    y1: 13.505,
    x2: 15.703,
    y2: 23.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cUser_svg__paint1_linear_3720_50968",
    x1: 68.922,
    y1: 20.505,
    x2: 18.235,
    y2: 20.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFE9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD0C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cUser_svg__paint2_linear_3720_50968",
    x1: 19.34,
    y1: 18.213,
    x2: 14.567,
    y2: 18.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cUser_svg__paint3_linear_3720_50968",
    x1: 19.34,
    y1: 18.213,
    x2: 14.567,
    y2: 18.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB7C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666,
    stopColor: "#AD0C24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCDD5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cUser_svg__filter0_d_3720_50968",
    x: 0.489,
    y: 0.591,
    width: 84.511,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.678431 0 0 0 0 0.0470588 0 0 0 0 0.141176 0 0 0 0.26 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3720_50968"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3720_50968",
    result: "shape"
  })))));
}
export default SvgCUser;